(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-read-more]').forEach(function (wrapper) {
      var btn = wrapper.querySelector('.text-block--read-more-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        wrapper.classList.toggle('is-expanded', !expanded);
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.textContent = expanded
          ? btn.dataset.readMoreLabel
          : btn.dataset.readLessLabel;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
